<div class="ipm-survey-table" [ngClass]="{ 'ipm-survey-table--mobile': configurationService.isMobileApp() }">
  <div
    class="ipm-survey-table__header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
    [cdkDragDisabled]="configurationService.isMobileApp()"
  >
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon svgIcon="icons-times-circle"></mat-icon>
    </button>
  </div>
  <div class="ipm-survey-table__sub-header">
    <app-text-field [field]="cmlField" [disabled]="getIdEditable()" (changed)="cmlFieldLabelChanged($event)"></app-text-field>
    <div class="ipm-survey-table__edit-container">
      <ng-container>
        @if (canEdit()) {
          @if (isEditMode) {
            <button
              mat-button
              (click)="cancelEdit()"
              class="ipm-raised-button ipm-raised-button--small ipm-survey-table__sub-header-button ipm-survey-table__sub-header-button--cancel"
            >
              <mat-icon svgIcon="icons-undo-alt"></mat-icon>
              {{ 'surveyMeasurementTable.cancel' | translate }}
            </button>
          }
          <button
            mat-raised-button
            (click)="toggleEditMode()"
            class="ipm-raised-button ipm-raised-button--small ipm-survey-table__sub-header-button ipm-survey-table__sub-header-button--edit"
            [ngClass]="{
              'ipm-survey-table__sub-header-button--save': isEditMode,
              'ipm-survey-table__sub-header-button ipm-survey-table__sub-header-button--edit': !isEditMode,
            }"
            [disabled]="isEditMode ? isSaveDisabled : false"
            color="primary"
          >
            <mat-icon [svgIcon]="isEditMode ? 'icon-save' : 'icons-pencil-alt'"></mat-icon>
            {{ isEditMode ? ('surveyMeasurementTable.save' | translate) : ('surveyMeasurementTable.editCml' | translate) }}
          </button>
        }
      </ng-container>
    </div>
  </div>
  <table
    mat-table
    multiTemplateDataRows
    [dataSource]="dataSource"
    class="ipm-survey-table__content-table"
    data-testid="survey-measurement-table"
  >
    <ng-container matColumnDef="cml">
      <th mat-header-cell *matHeaderCellDef class="ipm-survey-table__content-table-column">
        {{ 'surveyMeasurementTable.id' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        (click)="changeTableRowSelection(element)"
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--id"
      >
        @if (canEditMeasurementId(element)) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              type="text"
              [(ngModel)]="element.id"
              (input)="onMeasurmentIdChange($event, element)"
              [maxlength]="idMaxLength"
              data-testid="measurement-id-input"
            />
          </mat-form-field>
        } @else {
          <span>
            {{ element.id }}
          </span>
        }
      </td>
    </ng-container>

    <!-- Previous Column -->
    <ng-container matColumnDef="previousThk">
      <th mat-header-cell *matHeaderCellDef class="ipm-survey-table__content-table-column">
        {{ 'surveyMeasurementTable.previous' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        (click)="changeTableRowSelection(element)"
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--previous"
      >
        {{ formatPreviousMeasurement(element.previousMeasurement) }} {{ element.unitOfMeasurement }}
      </td>
    </ng-container>

    <!-- Current Column -->
    <ng-container matColumnDef="currentThk">
      <th mat-header-cell *matHeaderCellDef class="ipm-survey-table__content-table-column">
        {{ 'surveyMeasurementTable.current' | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        (click)="changeTableRowSelection(element)"
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--current"
        [ngStyle]="{ color: isMeasurementInAlarmState(element.measurement, element.previousMeasurement) ? 'red' : '' }"
        [ngClass]="{
          'ipm-survey-table__content-table-column--current-alarm': isMeasurementInAlarmState(
            element.measurement,
            element.previousMeasurement
          ),
          'ipm-survey-table__content-table-column--current-load': isThicknessMeasurementInProgress(element),
        }"
      >
        @if (canEditMeasurementValue()) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              type="text"
              inputmode="decimal"
              [(ngModel)]="element.measurement"
              #measurementModel="ngModel"
              (beforeinput)="onMeasurementBeforeInput($event)"
              (input)="onMeasurementChange(measurementModel, element)"
            />
          </mat-form-field>
        } @else {
          <span> {{ formatMeasurement(element.measurement) }} {{ element.unitOfMeasurement }} </span>
        }
      </td>
    </ng-container>

    <!-- Comment Column -->
    <ng-container matColumnDef="comment">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--action"
      ></th>
      <td
        mat-cell
        *matCellDef="let element"
        (click)="changeTableRowSelection(element)"
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--comment ipm-survey-table__content-table-column--action"
      >
        <button
          mat-icon-button
          color="primary"
          (click)="openComment(element)"
          [disabled]="canEditComment(element)"
          [ngClass]="{
            'ipm-survey-table__content-table-column--comment-white':
              isMeasurementInAlarmState(element.measurement, element.previousMeasurement) && element === commentRow,
          }"
          [matBadgeColor]="isMeasurementInAlarmState(element.measurement, element.previousMeasurement) ? 'warn' : 'primary'"
          matBadge="1"
          [matBadgeHidden]="element.comment === '' || element.comment === null"
          data-testid="comment-button"
        >
          <mat-icon
            [ngStyle]="{
              color: isCommentEmptyInAlarmStateOrSkipped(element.measurement, element.previousMeasurement, element.comment, element.status),
            }"
            svgIcon="icon-comment-alt"
          >
          </mat-icon>
          @if (isMeasurementInAlarmState(element.measurement, element.previousMeasurement) && element === commentRow) {
            <span class="ipm-survey-table__content-table-column-comment-background"></span>
          }
        </button>
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--action"
      ></th>
      <td
        mat-cell
        *matCellDef="let element"
        (click)="changeTableRowSelection(element)"
        class="ipm-survey-table__content-table-column ipm-survey-table__content-table-column--action"
      >
        <button mat-icon-button color="primary" (click)="deleteMeasurementId(element)" [disabled]="!canDeleteRow(element)">
          <mat-icon svgIcon="icon-trash"></mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Comment or Alarm Row -->
    <ng-container matColumnDef="commentDetail">
      <td
        mat-cell
        *matCellDef="let element; let dataIndex = dataIndex"
        [attr.colspan]="displayedColumns.length"
        [ngClass]="{
          'cdk-column-commentDetail--alarm': isMeasurementInAlarmState(element.measurement, element.previousMeasurement) ? 'red' : '',
        }"
      >
        <div class="comment-row" data-testid="comment-text-row" [class.comment-row--expanded]="commentRow && element === commentRow">
          @if (!isMeasurementInAlarmState(element.measurement, element.previousMeasurement) && alarmStage === 'comment') {
            <app-text-field
              [disabled]="disableComments"
              [field]="comments[dataIndex]"
              (changed)="onCommentChanged($event, dataIndex, element)"
              (changing)="onCommentChanging()"
            ></app-text-field>
            <mat-checkbox
              color="primary"
              [disabled]="element.measurement !== 0 || disableComments"
              [(ngModel)]="element.isSkipped"
              (change)="onSkippedChanged($event, dataIndex, element)"
              >{{ 'surveyMeasurementTable.markAsSkipped' | translate }}</mat-checkbox
            >
          } @else {
            @if (element.comment !== null) {
              <p class="cdk-column-commentDetail__header">{{ 'surveyMeasurementTable.keepThisReading' | translate }}</p>
              <app-text-field
                class="cdk-column-commentDetail__text-area"
                [disabled]="disableComments"
                [field]="comments[dataIndex]"
                (changed)="onCommentChanged($event, dataIndex, element)"
                (changing)="onCommentChanging()"
              ></app-text-field>
            } @else {
              <div class="cdk-column-commentDetail__retry-container">
                <mat-icon svgIcon="icon-exclamation-triangle" class="cdk-column-commentDetail__retry-icon"></mat-icon>
                <p class="cdk-column-commentDetail__retry-header">{{ 'surveyMeasurementTable.alarmCondition' | translate }}</p>
                <p class="cdk-column-commentDetail__retry-description">
                  <strong
                    >{{ 'surveyMeasurementTable.prev_short' | translate }}: {{ element.previousMeasurement }} -
                    {{ 'surveyMeasurementTable.current_short' | translate }}: {{ element.measurement }}</strong
                  >
                </p>
                <p class="cdk-column-commentDetail__retry-description cdk-column-commentDetail__retry-description--mb-1">
                  {{ 'surveyMeasurementTable.sureForThisReading' | translate }}
                </p>
                <div class="cdk-column-commentDetail__footer cdk-column-commentDetail__footer--space-between">
                  <button mat-button class="cdk-column-commentDetail__footer-button" (click)="keepThisReading(element)">
                    {{ 'surveyMeasurementTable.keepThisReadingCap' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    class="cdk-column-commentDetail__footer-button cdk-column-commentDetail__retry-button"
                    (click)="retry(element)"
                  >
                    <mat-icon svgIcon="icons-undo-alt"></mat-icon>
                    {{ 'surveyMeasurementTable.retry' | translate }}
                  </button>
                </div>
              </div>
            }
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{
        'ipm-survey-table__content-table-row--selected': isSelected(row),
        'ipm-survey-table__content-table-row--skipped': isSkipped(row),
      }"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['commentDetail']" class="comment-expand-row"></tr>
  </table>
  @if (canEdit()) {
    <button
      mat-raised-button
      (click)="addMeasurementPoint()"
      [disabled]="!isEditMode"
      class="ipm-raised-button ipm-raised-button--small ipm-survey-table__add-measurement-button"
      color="primary"
    >
      <mat-icon svgIcon="icon-plus"></mat-icon>
      {{ 'surveyMeasurementTable.addMeasurementPoint' | translate }}
    </button>
  }
</div>
<osc-utils-spinner #ISOspinner [spinnerId]="spinnerId"></osc-utils-spinner>
